import { Injectable, Injector } from '@angular/core';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ConfigurationService, } from './core/configuration.service';

import { EndpointFactory } from './core/endpoint-factory.service';

import { ContactRequest, ContactResponse } from '../models/contact/contact.model';


@Injectable()
export class ContactEndpoint extends EndpointFactory {
  
  private readonly _contactUrl: string = "/api/email/SendEmail";

  constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {
    super(http, configurations, injector);
  }
 
  sendEmail(request: ContactRequest) {
    return this.executeRequest <ContactRequest, ContactResponse>(this._contactUrl, request);
  }
}
